<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="配置信息"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="120px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="类型" prop="SettingType">
              <el-radio-group v-model="data.SettingType">
                <el-radio :label="1">不支持无理由退货</el-radio>
                <el-radio :label="2">支持无理由退货</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="退货期限" prop="SettingDay">
              <el-input
                v-model="data.SettingDay"
                placeholder="请填写退货期限"
                clearable
                @focus="handleFocus(data, 0)"
                @blur="handleBlur(data, 0)"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="自动收货期限" prop="DeliveryTime">
              <el-input
                v-model="data.DeliveryTime"
                placeholder="请填写自动收货期限"
                clearable
                @focus="handleFocus(data, 1)"
                @blur="handleBlur(data, 1)"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        SettingName: "",
        SettingType: 1,
        SettingDay: 0,
        DeliveryTime: 0,
      },

      api: require("@/api/sy/goodssetting").default,

      isMB: this.$store.state.isMB,
      rules: {
        SettingType: [{ required: true, message: "类型不能为空" }],
        SettingDay: [{ required: true, message: "退货期限不能为空" }],
        DeliveryTime: [{ required: true, message: "自动收货期限不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      //   loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  methods: {
    handleFocus(row, type) {
      if (type == 0) {
        if (row.SettingDay == 0) {
          row.SettingDay = null;
        }
      } else if (type == 1) {
        if (row.DeliveryTime == 0) {
          row.DeliveryTime = null;
        }
      }      
    },
    handleBlur(row, type) {
      if (type == 0) {
        if (row.SettingDay == null) {
          row.SettingDay = 0;
        }
      } else if (type == 1) {
        if (row.DeliveryTime == null) {
          row.DeliveryTime = 0;
        }
      }      
    },
    onCreateOpened(row) {},
    onEditOpened(row) {},
    onBeforeSave() {
      if (this.data.SettingType == 1) {
        this.data.SettingName = "不支持无理由退货";
      } else {
        if (this.data.SettingDay > 0) {
          this.data.SettingName =
            "支持" + this.data.SettingDay + "天无理由退货";
        } else {
          this.data.SettingName = "支持无理由退货";
        }
      }
    },
    onClosed() {},
  },
};
</script>